import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_billing_rates_grid_ComponentContextService } from './FootprintManager.billing_rates_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_billing_rates_gridComponentEntity {
  Id?: number, BillingAccessorialChargeTemplateLineId?: number, BillingCodeId?: number, BillingContractLineId?: number, LookupCode?: string, MinimumCharge?: number, PerAmount?: number, RangeEnd?: number, RangeStart?: number, Rate?: number, TypeId?: number, BillingRateTypes?: { Name?: string }}

interface IFootprintManager_billing_rates_gridComponentInParams {
  billingContractLineId?: number, edit: boolean, typeId: number, accessorialTemplateLineId?: number}


class FootprintManager_billing_rates_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_billing_rates_gridComponent;
  entity: IFootprintManager_billing_rates_gridComponentEntity;

  vars: { rateId?: number } = { };


 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    Rate_edit: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'change' }),
    MinimumCharge_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    RangeStart_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    RangeEnd_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    Rate: null,
    MinimumCharge: null,
    RangeStart: null,
    RangeEnd: null,
  }



  constructor(
    grid: FootprintManager_billing_rates_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_billing_rates_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Rate = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Rate,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['Rate_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.MinimumCharge = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.MinimumCharge,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['MinimumCharge_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.RangeStart = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.RangeStart,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['RangeStart_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    this.cells.RangeEnd = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.RangeEnd,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['RangeEnd_edit'] as DatexFormControl, null, false, false, '0.0000', '', null)
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_billing_rates_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_billing_rates_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const inParams = {
      $keys:[$resultKey],
      billingContractLineId:  $grid.inParams.billingContractLineId ,
      typeId:  $grid.inParams.typeId ,
      accessorialTemplateLineId:  $grid.inParams.accessorialTemplateLineId ,
    };
    const data = await this.$datasources.Invoices.ds_billing_rates_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_billing_rates_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Rate.displayControl as TextModel).text = $row.entity.Rate?.toString();
    (this.cells.Rate.editControl as NumberBoxModel).reset($row.entity.Rate);
    (this.cells.MinimumCharge.displayControl as TextModel).text = $row.entity.MinimumCharge?.toString();
    (this.cells.MinimumCharge.editControl as NumberBoxModel).reset($row.entity.MinimumCharge);
    (this.cells.RangeStart.displayControl as TextModel).text = $row.entity.RangeStart?.toString();
    (this.cells.RangeStart.editControl as NumberBoxModel).reset($row.entity.RangeStart);
    (this.cells.RangeEnd.displayControl as TextModel).text = $row.entity.RangeEnd?.toString();
    (this.cells.RangeEnd.editControl as NumberBoxModel).reset($row.entity.RangeEnd);

    await this.on_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      await this.on_save_existing_row();
      this.isNew = false;
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }

  //#region private flows
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $row: FootprintManager_billing_rates_gridComponentRowModel,
  $grid: FootprintManager_billing_rates_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_rates_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias 07/20/2023
  
  //Setting the rate id on a variable so we can work with the tab and new row
  $row.vars.rateId = $row.entity.Id;
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $row: FootprintManager_billing_rates_gridComponentRowModel,
  $grid: FootprintManager_billing_rates_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_rates_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/20/2023
  
  //Check if the editor was opened in edit mode
  if ($grid.inParams.edit) {
  
      $grid.canEdit = true;
  
  
  } else {
  
      $grid.canEdit = false;
  
  };
  }
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootprintManager_billing_rates_gridComponentRowModel,
  $grid: FootprintManager_billing_rates_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_rates_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 10/06/2023
  
  let typeId = 1;
  
  if ($utils.isDefined($grid.inParams.typeId)) {
      if ($grid.inParams.typeId > 1) {
          typeId = $grid.inParams.typeId;
      };
  };
  
  try {
  
      if (!$utils.isDefined($row.cells.Rate)) {
  
          await $shell.FootprintManager.openErrorDialog('Billing rate cannot be updated.', 'The rate cannot be blank.');
          return;
  
      } else {
  
          $row.cells.Rate.displayControl.text = $row.cells.Rate.editControl.value;
          $row.cells.MinimumCharge.displayControl.text = $row.cells.MinimumCharge.editControl.value;
          $row.cells.RangeStart.displayControl.text = $row.cells.RangeStart.editControl.value;
          $row.cells.RangeEnd.displayControl.text = $row.cells.RangeEnd.editControl.value;
  
          let rateId;
  
          if ($utils.isDefined($row.entity.Id)) {
              rateId = $row.entity.Id;
          } else {
              if ($utils.isDefined($row.vars.rateId)) {
                  rateId = $row.vars.rateId;
              };
          };
  
          //Run the rate validation
          const result = await $flows.Invoices.billing_rate_insert_or_update_flow({
              billingContractLineId: $grid.inParams.billingContractLineId,
              rateId: rateId,
              rangeStart: $row.cells.RangeStart.editControl.value,
              rangeEnd: $row.cells.RangeEnd.editControl.value,
              rate: $row.cells.Rate.editControl.value,
              minimumCharge: $row.cells.MinimumCharge.editControl.value,
              option: "grid",
              typeId: typeId
          });
  
          const range_validation = result.result;
          rateId = result.rateId;
          $row.vars.rateId = rateId;
  
          if ($utils.isDefined(range_validation) || !$utils.isDefined(rateId)) {
              await $shell.FootprintManager.openErrorDialog('Billing rate cannot be updated!', range_validation ?? "Unable to determine the rate id!");
              $grid.refresh();
          };
  
      };
  
  } catch (error) {
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
      const errorDescription = `Billing Contract Line Id ${$grid.inParams.billingContractLineId} - ${errorMessage}`;
      await $shell.FootprintManager.openErrorDialog('Update billing rate error', 'An error occurred during updating of the billing rate', [errorDescription], null, [{ message: errorDescription, detail: errorDetail }]);
  }
  
  
  
  
  
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-billing_rates_grid',
  templateUrl: './FootprintManager.billing_rates_grid.component.html'
})
export class FootprintManager_billing_rates_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_billing_rates_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['fit-content-table']);


  inParams: IFootprintManager_billing_rates_gridComponentInParams = { billingContractLineId: null, edit: null, typeId: null, accessorialTemplateLineId: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Rate: new GridHeaderModel(new HeaderStyles(null, null), 'Rate', 'Rate', true, false, null, false),       MinimumCharge: new GridHeaderModel(new HeaderStyles(null, null), 'MinimumCharge', 'Minimum charge', false, false, null, false),       RangeStart: new GridHeaderModel(new HeaderStyles(null, null), 'RangeStart', 'Range start', false, false, null, false),       RangeEnd: new GridHeaderModel(new HeaderStyles(null, null), 'RangeEnd', 'Range end', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_billing_rates_gridComponentRowModel[] = [];

  @Input('billingContractLineId') set $inParams_billingContractLineId(value: any) {
    this.inParams['billingContractLineId'] = value;
  }
  get $inParams_billingContractLineId(): any {
    return this.inParams['billingContractLineId'] ;
  }
  @Input('edit') set $inParams_edit(value: any) {
    this.inParams['edit'] = value;
  }
  get $inParams_edit(): any {
    return this.inParams['edit'] ;
  }
  @Input('typeId') set $inParams_typeId(value: any) {
    this.inParams['typeId'] = value;
  }
  get $inParams_typeId(): any {
    return this.inParams['typeId'] ;
  }
  @Input('accessorialTemplateLineId') set $inParams_accessorialTemplateLineId(value: any) {
    this.inParams['accessorialTemplateLineId'] = value;
  }
  get $inParams_accessorialTemplateLineId(): any {
    return this.inParams['accessorialTemplateLineId'] ;
  }

  topToolbar = {
      delete_rate: new ToolModel(new ButtonModel('delete_rate', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_billing_rates_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Billing rates';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.edit)) {
        this.$missingRequiredInParams.push('edit');
      }
      if(isNil(this.inParams.typeId)) {
        this.$missingRequiredInParams.push('typeId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      billingContractLineId:  $grid.inParams.billingContractLineId ,
      typeId:  $grid.inParams.typeId ,
      accessorialTemplateLineId:  $grid.inParams.accessorialTemplateLineId ,
    };
    try {
      const data = await this.$datasources.Invoices.ds_billing_rates_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_billing_rates_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_billing_rates_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: FootprintManager_billing_rates_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    await this.on_select();
  }

  async addRow(entity?: IFootprintManager_billing_rates_gridComponentEntity) {
    const row = new FootprintManager_billing_rates_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_delete(event = null) {
    return this.on_deleteInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_deleteInternal(
    $grid: FootprintManager_billing_rates_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_rates_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/21/2023
  
  const billing_rates = $grid.selectedRows;
  
  if (billing_rates.length === 0) {
  
      $shell.FootprintManager.openErrorDialog('Delete billing rate errors', 'No billing rates were selected.');
      return;
  
  } else {
  
      const delete_success = [];
      const delete_failures = [];
      const errorMsgList = [];
      const errorMsgListDetails = [];
  
      for (let billing_rate of billing_rates) {
  
          try {
  
              let delete_results = (await $flows.Invoices.billing_rate_delete_flow({ billingContractLineId: $grid.inParams.billingContractLineId, rateId: billing_rate.entity.Id, typeId: $grid.inParams.typeId }))
  
              if ($utils.isDefined(delete_results.result)) {
                  throw delete_results.result;
              };
  
              delete_success.push(billing_rate);
  
          } catch (error) {
  
              delete_failures.push(billing_rate);
              const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
              const errorDetail = $utils.isDefined(error?.error?.error) ? error?.error?.error : error;
              const errorDescription = `Billing rate ${billing_rate.entity.Id.toString()} - ${errorMessage}`;
              errorMsgList.push(errorDescription);
              errorMsgListDetails.push({ message: errorDescription, detail: errorDetail });
          }
      }
  
      // all succeeded
      if (delete_success.length === billing_rates.length) {
  
          const title = 'All billing rates(s) deleted';
          const message = `Billing rates(s) ${delete_success.map(c => c.entity.Id.toString()).join(',')} deleted`;
          await $shell.FootprintManager.openInfoDialog(title, message);
          await $grid.refresh();
  
      } else {
  
          // all failures
          if (delete_failures.length === billing_rates.length) {
  
              const title = 'All billing rate(s) failed to delete';
              const message = `Billing rate(s) ${delete_failures.map(c => c.entity.Id.toString()).join(',')} could not be deleted`;
              await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
  
          } else {
  
              const title = 'Some billing rates could not be deleted';
              const success = `Billing rate(s) ${delete_success.map(c => c.entity.Id.toString()).join(',')} were deleted.`;
              const errors = `The following billing rates(s) could not be deleted: ${delete_failures.map(c => c.entity.Id.toString()).join(',')}`;
              const message = `${success} \r\n\r\n${errors}`;
              await $shell.FootprintManager.openErrorDialog(title, message, errorMsgList, null, errorMsgListDetails);
              await $grid.refresh();
  
          }
      }
  }
  
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_billing_rates_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_rates_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/21/2023
  
  //Start as read only
  $grid.topToolbar.delete_rate.control.readOnly = true;
  //$grid.topToolbar.delete_rate.hidden = true;
  
  //If we get the edit parameter
  if ($grid.inParams.edit) {
  
      $grid.bottomToolbar.addLine.control.readOnly = false;
      $grid.bottomToolbar.addLine.hidden = false;
      $grid.canEdit = true;
      $grid.headers.Rate.required = true;   
  
  } else {
  
      $grid.bottomToolbar.addLine.control.readOnly = true;
      $grid.bottomToolbar.addLine.hidden = true;
      $grid.canEdit = false;
      $grid.headers.Rate.required = false;
  
  }
  }
  on_data_loaded(event = null) {
    return this.on_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_data_loadedInternal(
    $grid: FootprintManager_billing_rates_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_rates_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/21/2023
  
  //Start as read only
  $grid.topToolbar.delete_rate.control.readOnly = true;
  //$grid.topToolbar.delete_rate.hidden = true;
  
  //If we get the edit parameter
  if ($grid.inParams.edit) {
      $grid.bottomToolbar.addLine.control.readOnly = false;
      $grid.bottomToolbar.addLine.hidden = false;
      $grid.canEdit = true;
      $grid.headers.Rate.required = true;
  } else {
      $grid.bottomToolbar.addLine.control.readOnly = true;
      $grid.bottomToolbar.addLine.hidden = true;
      $grid.canEdit = false;
      $grid.headers.Rate.required = false;
  }
  }
  on_select(event = null) {
    return this.on_selectInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_selectInternal(
    $grid: FootprintManager_billing_rates_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_billing_rates_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  //O.Arias - 07/21/2023
  
  //If we get the edit parameter
  if ($grid.inParams.edit) {
      if ($grid.selectedRows.length === 0) {
          $grid.topToolbar.delete_rate.control.readOnly = true;
          //$grid.topToolbar.delete_rate.hidden = true;
      } else {
          $grid.topToolbar.delete_rate.control.readOnly = false;
          //$grid.topToolbar.delete_rate.hidden = false;
      };
  } else {
      $grid.topToolbar.delete_rate.control.readOnly = true;
      //$grid.topToolbar.delete_rate.hidden = true;
  };
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
